import type { AgentSkillMeta } from './types';
import type { SupportedLanguage } from '../../../utils/languageDetection';

/** Word agent skills always interact in Hebrew. */
export const SKILL_AGENT_LANGUAGE: SupportedLanguage = 'he';

/** Fallback built-in skills when API is unavailable. */
export const BUILT_IN_SKILLS_FALLBACK: AgentSkillMeta[] = [
  {
    id: 'email-client-request-merge',
    name: 'מיזוג בקשות לקוח ממייל',
    description: 'הדבק בקשות לקוח ממייל והוסף אותן למסמך Word הפתוח.',
    category: 'built-in',
    icon: 'mail-merge',
  },
];

/** Prefer Hebrew labels from fallback catalog when API returns English metadata. */
export function localizeSkillMeta(skill: AgentSkillMeta): AgentSkillMeta {
  const fallback = BUILT_IN_SKILLS_FALLBACK.find((s) => s.id === skill.id);
  if (!fallback) return skill;
  return { ...skill, name: fallback.name, description: fallback.description };
}

export const EMAIL_CLIENT_REQUEST_MERGE_ID = 'email-client-request-merge';
